import { faFacebookF, faGithub, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import coverPhoto from '../assets/cover.png';
import profilePhoto from '../assets/profile.jpg';
export function ProfileCard() {
    const texts = ["Web Developer", "Software Engineer", "Software Developer"];
    const [index, setIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const [forward, setForward] = useState(true);
    const [blink, setBlink] = useState(true);

    useEffect(() => {
        if (subIndex === texts[index].length + 1 && forward) {
            setTimeout(() => setForward(false), 1000);
            return;
        }

        if (subIndex === 0 && !forward) {
            setTimeout(() => {
                setForward(true);
                setIndex((prev) => (prev + 1) % texts.length);
            }, 1000);
            return;
        }

        const timeout = setTimeout(() => {
            setSubIndex((prev) => prev + (forward ? 1 : -1));
        }, forward ? 100 : 50);

        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subIndex, forward]);

    useEffect(() => {
        const blinkTimeout = setTimeout(() => {
            setBlink((prev) => !prev);
        }, 500);
        return () => clearTimeout(blinkTimeout);
    }, [blink]);
    return (

        <div
            className="max-w-2xl mx-2 mt-1 md:mt-0 sm:max-w-sm md:max-w-sm lg:max-w-sm xl:max-w-sm sm:mx-auto md:mx-auto lg:mx-auto xl:mx-auto  bg-white shadow-xl rounded-lg text-gray-900">

            <div className="rounded-t-lg h-48 overflow-hidden object-cover">
                <img className="object-cover object-top w-full" src={coverPhoto} alt='coverPhoto' />
            </div>
            <div className="mx-auto w-32 h-32 relative -mt-16 border-4 border-white rounded-full overflow-hidden">
                <img className="object-cover object-center h-32" src={profilePhoto} alt='profile' />
            </div>
            <div className="text-center mt-2">
                <h2 className="font-semibold">Saiful Islam Shanto</h2>
                <p className="text-gray-500">  {`${texts[index].substring(0, subIndex)}${blink ? "|" : "_"}`}</p>
            </div>
            <ul className="py-4 mt-2 text-gray-700 flex items-center justify-around">
                <li >
                    <a href='https://www.linkedin.com/in/saiful-shant0/' target='_blank' rel='noreferrer'>  <FontAwesomeIcon icon={faLinkedinIn} className="text-blue-600" /></a>

                </li>
                <li >
                    <a href='https://github.com/shant00' target='_blank' rel='noreferrer'>   <FontAwesomeIcon icon={faGithub} className="text-black" /></a>

                </li>
                <li >
                    <a href='https://www.facebook.com/saifulshant0' target='_blank' rel='noreferrer'>  <FontAwesomeIcon icon={faFacebookF} className="text-blue-700" /></a>

                </li>
                <li >
                    <a href='https://x.com/saifulshant0' target='_blank' rel='noreferrer'>
                        <FontAwesomeIcon icon={faXTwitter} className="text-black" /></a>

                </li>

            </ul>
            <div className="p-4 border-t mx-8 mt-2">
                <a href="Resume-of-shanto.pdf" download="Resume-of-shanto.pdf">
                    <button className="block mx-auto rounded-full border border-blue-500 hover:bg-blue-200 font-semibold text-gray-700 px-6 py-2 font-normal">
                        Download Resume
                    </button>
                </a>

            </div>
        </div>

    );
}